import axios from '@/utils/axios';
import qs from 'qs';
const userApi = {
  //获取微信配置
  getAuthority: (param?: any) =>
    axios.get(`CaterWeixin/v2/getJsParams.json?` + qs.stringify(param), {}),
};

export default { userApi };
